/**
 * The world board's refusals, in words. A rejected submission used to be
 * indistinguishable from being offline: the run was saved locally, the
 * board silently had no row, and the player could not know why. A
 * refusal is not a network problem, so it gets said, once, in a toast.
 */
export function boardRefusalText(reason) {
  switch (reason) {
    case 'invalid_time':
    case 'ghost_length':
    case 'ghost_ends_early':
      return 'RECORD SAVED HERE ONLY\nTOO LONG FOR THE WORLD BOARD (10 MIN MAX)';
    case 'rate_limited':
      return 'RECORD SAVED HERE\nBOARD BUSY, IT WILL TAKE THE NEXT ONE';
    case 'invalid_name':
      return 'RECORD SAVED HERE ONLY\nTHE BOARD REFUSED THAT CALLSIGN';
    default:
      return `RECORD SAVED HERE ONLY\nBOARD REFUSED IT (${String(reason ?? 'unknown').toUpperCase()})`;
  }
}
